import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Chip,
} from '@mui/material';
import { useMovies } from '../../hooks/useMovies';
import { useAuth } from '../../contexts/AuthContext';

const Watchlist = () => {
  const { movies, loading, refresh, getWatchlist } = useMovies();
  const { user } = useAuth();
  const [watchlist, setWatchlist] = useState([]);

  useEffect(() => {
    if (user) {
      fetchWatchlist();
    }
  }, [user]);

  const fetchWatchlist = async () => {
    try {
      const list = await getWatchlist('WANT_TO_WATCH');
      setWatchlist(list);
    } catch {
      setWatchlist([]);
    }
  };

  const handleRefresh = async () => {
    await refresh();
    fetchWatchlist();
  };

  if (loading) {
    return <Typography>Loading your watchlist...</Typography>;
  }

  if (!watchlist || watchlist.length === 0) {
    return <Typography>Your watchlist is empty.</Typography>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Your Watchlist</Typography>
      <Button onClick={handleRefresh} sx={{ mb: 2 }} variant="outlined">Refresh</Button>
      <Grid container spacing={2}>
        {watchlist.map((movie) => (
          <Grid item key={movie.id} xs={12} sm={6} md={4} lg={3}>
            <Card>
              <CardMedia
                component="img"
                height="240"
                image={movie.posterPath || movie.poster || '/placeholder-movie.svg'}
                alt={movie.name || movie.title}
              />
              <CardContent>
                <Typography variant="h6" noWrap>{movie.name || movie.title}</Typography>
                <Chip label={movie.status} size="small" sx={{ mt: 1 }} />
              </CardContent>
              <CardActions>
                {/* Additional Watchlist item actions like Remove/Update status can be added here */}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Watchlist;